module.exports = __webpack_public_path__ + "static/media/user-profile-bg.977c2e8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-profile-bg.jpg
// module id = 770
// module chunks = 0